<template>
  <v-card class="ma-0 mt-0 pt-0" width="100%" flat>
    <v-card-title class="pt-0"> {{ $t("excelUpload") }} {{ $t(type) }} </v-card-title>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-row>
          <v-col cols="12" v-if="digikalaProp">
            <autocomplete
              v-model="digikalaPanel"
              :rules="[(v) => !!v || $t('is-required')]"
              :title="$t('digikalaPanelsName')"
              type="digikalaPanels"
            />
          </v-col>
          <v-col v-if="downloadLink" cols="12" class="py-0">
            <a
              :href="downloadLink"
              download
              type="button"
              class="mt-2 v-btn v-btn--block v-btn--outlined theme--light v-size--small green--text"
            >
              {{ $t("sampleFile") }}
              <v-icon color="green" class="mx-1"> mdi-download </v-icon>
            </a>
          </v-col>
          <v-col class="pb-0">
            <v-btn
              color="primary"
              outlined
              style="width: 100%"
              height="32"
              :loading="isSelecting"
              @click="handleFileImport"
            >
              <v-icon left> mdi-upload </v-icon>
              {{ buttonText }}
            </v-btn>

            <!-- Create a File Input that will be hidden but triggered with JavaScript -->
            <input
              ref="uploader"
              class="d-none"
              type="file"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              @change="onFileChanged"
            />
          </v-col>
          <v-col cols="12" md="12">
            <dropbox
              v-model="file"
              :title="$t('addFile') + '(dropbox)'"
              :extensions="['.xlsx', '.csv']"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="import-arrow-cell" />
                    <th>
                      {{ $t("fileName") }}
                    </th>
                    <th>
                      {{ $t("status") }}
                    </th>
                    <th>
                      {{ $t("doneCountItem") }}
                    </th>
                    <th>
                      {{ $t("registerar") }}
                    </th>
                    <th>
                      {{ $t("time") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in items">
                    <tr
                      :key="item.id"
                      :class="{
                        'import-row-failed': isImportFailed(item.status),
                        'import-row-expandable': hasImportErrors(item),
                      }"
                      @click="toggleImportExpand(item)"
                    >
                      <td class="import-arrow-cell">
                        <v-icon
                          v-if="hasImportErrors(item)"
                          small
                          class="import-arrow-icon"
                        >
                          {{
                            isImportExpanded(item) ? "mdi-chevron-up" : "mdi-chevron-down"
                          }}
                        </v-icon>
                      </td>
                      <td>{{ item.file.title }}</td>
                      <td>
                        <v-chip
                          small
                          label
                          dark
                          :color="getImportStatusColor(item.status)"
                        >
                          {{ getImportStatusLabel(item.status) }}
                        </v-chip>
                      </td>
                      <td>{{ item.count_item }}</td>
                      <td>{{ item.user.firstname }} {{ item.user.lastname }}</td>
                      <td>{{ item.time }}</td>
                    </tr>
                    <tr v-if="isImportExpanded(item)" :key="`${item.id}-errors`">
                      <td colspan="6" class="import-error-detail-cell pa-3">
                        <div class="d-flex align-center flex-wrap gap-2 mb-2">
                          <span class="text-body-2 font-weight-medium">
                            {{ $t("import-error-details") }}
                            <v-chip x-small outlined>
                              {{ getImportErrorItems(item).length }}
                            </v-chip>
                            {{ $t("case") }}
                          </span>
                        </div>
                        <div
                          v-for="(err, i) in getImportErrorItems(item)"
                          :key="i"
                          class="d-flex align-center flex-wrap gap-2 mb-2"
                        >
                          <v-chip x-small color="error" outlined>
                            {{ $t("row") }} {{ err.row }}
                          </v-chip>
                          <span class="text-body-2">{{ err.message }}</span>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col cols="6" class="px-1">
            <v-btn color="primary" class="mr-0" :loading="isLoading" @click="create">
              {{ $t("submit") }}
            </v-btn>
          </v-col>
          <v-col cols="6" class="px-2">
            <v-btn color="grey" outlined class="float-left" @click="$emit('close')">
              {{ $t("close") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
// import aicomplete from '../../components/general/AIcomplete/index'
import General from "../../../../../Mixins/general";
import Snakbar from "../snakbar/snakbar";
import Dropbox from "../../general/dropbox/index";
export default {
  name: "UploadDialog",
  components: {
    Snakbar,
    Dropbox,
  },
  mixins: [General],
  props: ["typeProp", "getItem", "digikalaProp"],
  data: () => ({
    options: {
      locale: "en-US",
      prefix: "",
      suffix: " ",
      precision: 0,
    },
    isSelecting: false,
    selectedFile: null,
    render: false,
    isLoading: false,
    alert: false,
    digikalaPanel: null,
    downloadLink: null,
    type: null,
    id: null,
    valid: null,
    items: null,
    file: null,
    expandedImportId: null,
  }),
  computed: {
    buttonText() {
      return this.selectedFile ? this.selectedFile.name : this.$t("uploadFromSystem");
    },
  },
  watch: {
    getItem() {
      if (this.getItem) {
        this.expandedImportId = null;
        this.getItems();
      }
    },
    typeProp() {
      this.type = this.typeProp;
    },
  },
  beforeMount() {},
  mounted() {
    if (this.typeProp) {
      this.type = this.typeProp;
      if (this.type === "product") {
        this.downloadLink = "/sample/product.xlsx";
      }
      if (this.type === "productIntegrator") {
        this.downloadLink = "/sample/integrator.xlsx";
      }
      if (this.type === "customer") {
        this.downloadLink = "/sample/customer.xlsx";
      }
      if (this.type === "translationPrice") {
        this.downloadLink = "/sample/translation.xlsx";
      }
      if (this.type === "accountStructure") {
        this.downloadLink = "/sample/accountStructure.xlsx";
      }
      if (this.type === "accountingDocument") {
        this.downloadLink = "/sample/accountingDocument.xlsx";
      }
      if (this.type === "invoice") {
        this.downloadLink = "/sample/invoice.xlsx";
      }
      if (this.type === "entrepot") {
        this.downloadLink = "/sample/entrepot_.xlsx";
      }
      if (this.type === "pricing") {
        this.downloadLink = "/sample/pricing.xlsx";
      }
      if (this.type === "warehouseHandling") {
        this.downloadLink = "/sample/warehouseHandling.xlsx";
      }
      if (this.type === "production") {
        this.downloadLink = "/sample/production.xlsx";
      }
      if (this.type === "productIntegratorImport") {
        this.downloadLink = "/sample/integrator.xlsx";
      }
      if (this.type === "barcode") {
        this.downloadLink = "/sample/barcode.xlsx";
      }
      if (this.type === "recieve" || this.type === "pay") {
        this.downloadLink = "/sample/pay.xlsx";
      }
      if (this.type === "recieveCheck") {
        this.downloadLink = "/sample/recieveCheckSample.xlsx";
      }
    }
    this.getItems();
  },
  methods: {
    create() {
      var app = this;
      app.isLoading = true;
      var formData = new FormData();
      formData.append("selectedFile", this.selectedFile);
      formData.append("ref_type", this.digikalaPanel ? this.digikalaPanel.name : null);
      formData.append("file", this.file);
      formData.append("type", this.type);
      formData.append("items", this.items);
      app.$axios
        .post(this.$endpoint + "import", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          app.$emit("close");
          app.$emit("input", res.data);
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (this.isLoading = false));
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "import", {
          params: {
            getType: "list",
            type: app.type,
          },
        })
        .then((res) => {
          res = res.data;
          app.items = res;
          app.expandedImportId = null;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    handleFileImport() {
      this.isSelecting = true;

      // After obtaining the focus when closing the FilePicker, return the button state to normal
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      // Trigger click on the FileInput
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.selectedFile = e.target.files[0];
      // Do whatever you need with the file, liek reading it with FileReader
    },
    getImportStatusColor(status) {
      const colors = {
        validate: "orange",
        validating: "orange",
        completed: "blue",
        done: "blue",
        failed: "red",
        error: "red",
        unsuccessful: "red",
      };
      return colors[status] || "grey";
    },
    getImportStatusLabel(status) {
      return this.$t(status);
    },
    isImportFailed(status) {
      return ["failed", "error", "unsuccessful"].includes(status);
    },
    hasImportErrors(item) {
      return (
        this.isImportFailed(item.status) &&
        item.errors &&
        Array.isArray(item.errors.items) &&
        item.errors.items.length > 0
      );
    },
    getImportErrorItems(item) {
      return item.errors && item.errors.items ? item.errors.items : [];
    },
    isImportExpanded(item) {
      return this.expandedImportId === item.id;
    },
    toggleImportExpand(item) {
      if (!this.hasImportErrors(item)) return;
      this.expandedImportId = this.expandedImportId === item.id ? null : item.id;
    },
  },
};
</script>

<style scoped>
.import-arrow-cell {
  width: 32px;
  padding: 0 4px !important;
}
.import-arrow-icon {
  color: rgba(0, 0, 0, 0.87) !important;
}
.import-row-failed > td {
  background-color: #ffebee !important;
}
.import-row-failed:hover > td {
  background-color: #ffcdd2 !important;
}
.import-row-expandable {
  cursor: pointer;
}
.import-error-detail-cell {
  background-color: #fafafa;
  border-top: 1px solid #ffcdd2;
}
</style>
